module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14tkX3y/tc-custom/9798891553217.jpg?1716663165544",
      "alt": "This image is the cover for the book McKenna Goes Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("McKenna Goes Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("The Civil War has ended, and McKenna is drawn back to Charleston, the cradle of her childhood and the echoes of a tumultuous past. As she steps into the post-war remnants of her once-beloved city, questions haunt her—does her home endure, or has it succumbed to the ruin? Are the ghosts of her youth lurking in the shadows of devastation, or will the rubble reveal secrets long buried? Returning to the city of her youth, now marred by the tragedy of conflict, McKenna must summon her resilience to confront the Charleston that awaits her, forever altered by the War’s relentless tide.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debbie Dee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto, sans-serif",
      "font-size": "14px"
    }
  }, [_vm._v("Debbie Dee was raised on a dairy farm in Delta, Ohio. She attended the University of Toledo and graduated as a dual major in biology and education. She taught at the Northwood School District for thirty-five years as a Language Arts teacher. Upon retirement, she fulfilled her dream of writing a trilogy about the Civil War. Deb married her high school sweetheart, Brian Towns, in 1980 and raised two wonderful sons, Kiel and Tyler. Kiel is married to Ashley Towns and Tyler is married to Lauren Towns. Brian and Deb moved south to North Georgia where they currently reside.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0